function showSizeChart(e) {
    if (e && e.preventDefault) {
        e.preventDefault();
    }
    let sizeChartModal = document.querySelector('.size-chart-modal');
    if (!sizeChartModal || sizeChartModal.length === 0) {
        initializeSizeChart();
        sizeChartModal = document.querySelector('.size-chart-modal');
    }
    const bwlDivElem = document.querySelector('.brand-we-love');
    if (bwlDivElem) {
        sizeChartModal.querySelector('#bwl').classList.remove('display_none');
        sizeChartModal.querySelector('#global').classList.add('display_none');
    } else {
        sizeChartModal.querySelector('#global').classList.remove('display_none');
        sizeChartModal.querySelector('#bwl').classList.add('display_none');
    }
    openSizeChartModal();
}

function openSizeChartModal() {
  document.querySelector('.size-chart-modal').classList.remove('display_none');
  document.body.style.overflow = 'hidden';
}

function closeSizeChartModal(e) {
  if (e) {
    e.preventDefault();
  }
  document.querySelector('.size-chart-modal').classList.add('display_none');
  document.body.style.overflow = '';
}

function initializeSizeChart() {
    const sizeChartModal = createSizeChartModal();
    document.body.appendChild(sizeChartModal);
}

function createSizeChartModal() {
    const wrapper = document.createElement('div');
    wrapper.className = 'size-chart-modal fixed inset-0 bg-black/50 display_none z-50 flex items-baseline lg:items-center justify-center';
    wrapper.innerHTML = `
    <div class="size-chart-content bg-white max-w-[860px] pt-10 p-4 sm:p-4 relative max-h-[80vh] overflow-y-auto h-full lg:h-auto lg:max-h-[80vh] mx-[4vh] my-auto md:my-16 md:p-5">
      <button class="size-chart-close absolute top-4 right-4 text-gray-600 hover:text-black text-2xl">&times;</button>
    <style>
    .size-chart table th, .size-chart table td {
        padding: 5px;
        text-align: center;
        border: 1px solid #171011;
        font-size: 14px;
    }
    .size-chart .how-to-measure ul {
        list-style: disc;
        padding-left: 30px;
        margin-top: 10px;
        font-size: 14px;
    }
    .chart-section .chart-section-item {
        color: grey;
    }
    .chart-section .chart-section-item.active {
        color: #000;
    }    
    @media (min-width: 992px) {
        .how-to-measure ul {
            font-size: 16px;
        }
    }
    </style>
    <div id="bwl" class="display_none">
    <div class="size-chart">
    <style>
    .chart-section{display : flex; flex-direction: row; color : grey;}
    .active{color : black ;}
    .chart-section-item:hover{color : black ;}
    #content{ 
        width : 100%;
        font-family: Urbanist, "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: 600;
    }
    table.table-auto-mobile  tr td {
        border: none !important;
    }
    table{
        width : 100%
    }
    .h2{
        font-weight: 600;
    }
    .chart-section-item{ margin-left : 0.5rem; margin-right : 0.5rem;}
    </style>
    <div data-role="content" id="content">

    <div class="h2 text-center mb-4">SIZE CHART</div>
    <div class="p font-bold mb-4"> You can refer to these size charts to find your perfect fit</div>
    <div class="p mb-4"> We know online shopping can be tricky! Since our styles come from so many different designers. sizing can really vary from piece to piece. The fit and sizing section on each product's page will provide more detailed information about that product’s fit.</div>
    <div class="mb-5 sct sizeChartTable-mobile sm:display_none display_block">
        <table class="table-sc-0 table-auto-mobile">
        <thead>
            <tr>
            <td>AVERAGE</td>
            <td>SIZE</td>
            <td>BUST</td>
            <td>WAIST</td>
            <td>HIPS</td>
            </tr>
        </thead>
        <tbody>
        <tr>
            <td>XS</td>
            <td>00</td>
            <td>31"</td>
            <td>23"</td>
            <td>33"</td>
            </tr>
            <tr>
            <td>XS</td>
            <td>0</td>
            <td>32"</td>
            <td>24"</td>
            <td>34.5"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>2</td>
            <td>32.5"</td>
            <td>24.5"</td>
            <td>35"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>4</td>
            <td>33.5"</td>
            <td>25.5"</td>
            <td>36"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>6</td>
            <td>34.5"</td>
            <td>26.5"</td>
            <td>37"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>8</td>
            <td>35.5"</td>
            <td>27.5"</td>
            <td>38"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>10</td>
            <td>36.5"</td>
            <td>28.5"</td>
            <td>39"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>12</td>
            <td>38"</td>
            <td>30.5"</td>
            <td>40.5"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>14</td>
            <td>39.5"</td>
            <td>31.5"</td>
            <td>42"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>16</td>
            <td>41"</td>
            <td>33"</td>
            <td>43.5"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="mb-5 sct sizeChartTable sm:display_block display_none">
    <table class="table-sc-0 table-auto">
        <thead>
            <tr>
            <th colspan="12">
            BWL  Sizing Chart 
            </th>
            </tr>
            <tr class="bg-black text-white">
            <td>AVERAGE</td>
            <td>XS</td>
            <td>XS</td>
            <td>S</td>
            <td>S</td>
            <td>M</td>
            <td>M</td>
            <td>L</td>
            <td>L</td>
            <td>XL</td>
            <td>XL</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>SIZE</td>
            <td>00</td>
            <td>0</td>
            <td>2</td>
            <td>4</td>
            <td>6</td>
            <td>8</td>
            <td>10</td>
            <td>12</td>
            <td>14</td>
            <td>16</td>
            </tr>
            <tr>
            <td>BUST</td>
            <td>31"</td>
            <td>32"</td>
            <td>32.5"</td>
            <td>33.5"</td>
            <td>34.5"</td>
            <td>35.5"</td>
            <td>36.5"</td>
            <td>38"</td>
            <td>39.5"</td>
            <td>41"</td>
            </tr>
            <tr>
            <td>WAIST</td>
            <td>23"</td>
            <td>24"</td>
            <td>24.5"</td>
            <td>25.5"</td>
            <td>26.5"</td>
            <td>27.5"</td>
            <td>28.5"</td>
            <td>30.5"</td>
            <td>31.5"</td>
            <td>33"</td>
            </tr>
            <tr>
            <td>HIPS</td>
            <td>33"</td>
            <td>34.5"</td>
            <td>35"</td>
            <td>36"</td>
            <td>37"</td>
            <td>38"</td>
            <td>39"</td>
            <td>40.5"</td>
            <td>42"</td>
            <td>43.5"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="how-to-measure mb-5">
        <div class="h4">how to measure</div>
        <ul>
        <li>
            For the best fit, measure over the undergarments you'll be wearing.
            Stand with your feet approximately 12" apart.
        </li>
        <li>
            Bust: Measure around the chest at the fullest part of the bust. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Natural Waist: Measure around your waist at the narrowest part. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Hips: Measure around your hips at widest part. Usually about eight
            inches below waist. The tape should be held securely around the body but
            not tight.
        </li>
        </ul>
    </div>

    </div>
    </div>
    </div>
    <div id="global">
    <div class="size-chart">
        <style>
        .chart-section {
            display: flex;
            flex-direction: row;
            color: grey;
        }
        .active {
            color: black;
        }
        .chart-section-item:hover {
            color: black;
        }
        #content {
            width: 100%;
        }
        table.table-auto-mobile tr td {
            border: none !important;
        }
        .chart-section-item {
            margin-left: 0.5rem;
            margin-right: 0.5rem;
        }
        .hidden-table {
            display: none;
        }
        </style>

    <div class="h2 text-center mb-4">SIZE CHART</div>
    <div class="p font-bold mb-4">
        All women are not created equal. Refer to these size charts to find your
        perfect fit
    </div>
    </div>
    <div class="h4 mb-4 chart-section"><div class="cursor-pointer chart-section-item sm:mx-6 active">average</div><div class="cursor-pointer chart-section-item sm:mx-6">petite</div><div class="cursor-pointer chart-section-item sm:mx-6">tall</div><div class="cursor-pointer chart-section-item sm:mx-6">shoes</div><div class="cursor-pointer chart-section-item sm:mx-6">plus</div><div class="cursor-pointer chart-section-item sm:mx-6">ftf</div><div class="cursor-pointer chart-section-item sm:mx-6">plus-shoes</div></div>

    <div class="size-chart size-sub-chart" id="average">
    <div class="mb-5 sct sizeChartTable-mobile sm:display_none display_block">
        <table class="table-sc-0 table-auto-mobile">
        <thead>
            <tr>
            <td>AVERAGE</td>
            <td>SIZE</td>
            <td>BUST</td>
            <td>WAIST</td>
            <td>HIPS</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>XS</td>
            <td>0</td>
            <td>32.5"</td>
            <td>25"</td>
            <td>34.5"</td>
            </tr>
            <tr>
            <td>XS</td>
            <td>2</td>
            <td>33.5"</td>
            <td>26"</td>
            <td>35.5"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>4</td>
            <td>34.5"</td>
            <td>27"</td>
            <td>36.5"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>6</td>
            <td>35.5"</td>
            <td>28"</td>
            <td>37.5"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>8</td>
            <td>36.5"</td>
            <td>29"</td>
            <td>38.5"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>10</td>
            <td>37.5"</td>
            <td>30"</td>
            <td>39.5"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>12</td>
            <td>39"</td>
            <td>31.5"</td>
            <td>41"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>14</td>
            <td>40.5"</td>
            <td>33"</td>
            <td>42.5"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>16</td>
            <td>42"</td>
            <td>34.5"</td>
            <td>44"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>18</td>
            <td>43.5"</td>
            <td>36"</td>
            <td>45.5"</td>
            </tr>
            <tr>
            <td>XXL</td>
            <td>20</td>
            <td>45"</td>
            <td>37.5"</td>
            <td>47"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="mb-5 sct sizeChartTable sm:display_block display_none">
    <table class="table-sc-0 table-auto">
        <thead>
            <tr>
            <th colspan="12">
                Our average styles are proportioned to fit women 5'5" to 5'8" tall
            </th>
            </tr>
            <tr>
            <td class="bg-black text-white">AVERAGE</td>
            <td>XS</td>
            <td>XS</td>
            <td>S</td>
            <td>S</td>
            <td>M</td>
            <td>M</td>
            <td>L</td>
            <td>L</td>
            <td>XL</td>
            <td>XL</td>
            <td>XXL</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>SIZE</td>
            <td>0</td>
            <td>2</td>
            <td>4</td>
            <td>6</td>
            <td>8</td>
            <td>10</td>
            <td>12</td>
            <td>14</td>
            <td>16</td>
            <td>18</td>
            <td>20</td>
            </tr>
            <tr>
            <td>BUST</td>
            <td>32.5"</td>
            <td>33.5"</td>
            <td>34.5"</td>
            <td>35.5"</td>
            <td>36.5"</td>
            <td>37.5"</td>
            <td>39"</td>
            <td>40.5"</td>
            <td>42"</td>
            <td>43.5"</td>
            <td>45"</td>
            </tr>
            <tr>
            <td>WAIST</td>
            <td>25"</td>
            <td>26"</td>
            <td>27"</td>
            <td>28"</td>
            <td>29"</td>
            <td>30"</td>
            <td>31.5"</td>
            <td>33"</td>
            <td>34.5"</td>
            <td>36"</td>
            <td>37.5"</td>
            </tr>
            <tr>
            <td>HIPS</td>
            <td>34.5"</td>
            <td>35.5"</td>
            <td>36.5"</td>
            <td>37.5"</td>
            <td>38.5"</td>
            <td>39.5"</td>
            <td>41"</td>
            <td>42.5"</td>
            <td>44"</td>
            <td>45.5"</td>
            <td>47"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="how-to-measure mb-5">
        <div class="h4">how to measure</div>
        <ul>
        <li>
            For the best fit, measure over the undergarments you'll be wearing.
            Stand with your feet approximately 12" apart.
        </li>
        <li>
            Bust: Measure around the chest at the fullest part of the bust. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Natural Waist: Measure around your waist at the narrowest part. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Hips: Measure around your hips at widest part. Usually about eight
            inches below waist. The tape should be held securely around the body but
            not tight.
        </li>
        </ul>
    </div>
    </div>  

    <div class="size-chart size-sub-chart display_none" id="petite">
    <div class="mb-5 sct sizeChartTable-mobile sm:display_none display_block">
        <table class="table-sc-1 table-auto-mobile">
        <thead>
            <tr>
            <td>PETITE</td>
            <td>SIZE</td>
            <td>BUST</td>
            <td>WAIST</td>
            <td>HIPS</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>XXS</td>
            <td>00</td>
            <td>30.5"</td>
            <td>23"</td>
            <td>32.5"</td>
            </tr>
            <tr>
            <td>XS</td>
            <td>0</td>
            <td>31.5"</td>
            <td>24"</td>
            <td>33.5"</td>
            </tr>
            <tr>
            <td>XS</td>
            <td>2</td>
            <td>32.5"</td>
            <td>25"</td>
            <td>34.5"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>4</td>
            <td>33.5"</td>
            <td>26"</td>
            <td>35.5"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>6</td>
            <td>34.5"</td>
            <td>27"</td>
            <td>36.5"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>8</td>
            <td>35.5"</td>
            <td>28"</td>
            <td>37.5"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>10</td>
            <td>36.5"</td>
            <td>29"</td>
            <td>38.5"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>12</td>
            <td>38"</td>
            <td>40"</td>
            <td>40"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>14</td>
            <td>39.5"</td>
            <td>32"</td>
            <td>41.5"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>16</td>
            <td>41"</td>
            <td>33.5"</td>
            <td>43"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>18</td>
            <td>42.5"</td>
            <td>35"</td>
            <td>44.5"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="mb-5 sct sizeChartTable sm:display_block display_none">
    <table class="table-sc-1 table-auto">
        <thead>
            <tr>
            <th colspan="12">
                Our petite styles are proportioned to fit women 5'4" and under
            </th>
            </tr>
            <tr>
            <td>PETITE</td>
            <td>XXS</td>
            <td>XS</td>
            <td>XS</td>
            <td>S</td>
            <td>S</td>
            <td>M</td>
            <td>M</td>
            <td>L</td>
            <td>L</td>
            <td>XL</td>
            <td>XL</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>SIZE</td>
            <td>00</td>
            <td>0</td>
            <td>2</td>
            <td>4</td>
            <td>6</td>
            <td>8</td>
            <td>10</td>
            <td>12</td>
            <td>14</td>
            <td>16</td>
            <td>18</td>
            </tr>
            <tr>
            <td>BUST</td>
            <td>30.5"</td>
            <td>31.5"</td>
            <td>32.5"</td>
            <td>33.5"</td>
            <td>34.5"</td>
            <td>35.5"</td>
            <td>36.5"</td>
            <td>38"</td>
            <td>39.5"</td>
            <td>41"</td>
            <td>42.5"</td>
            </tr>
            <tr>
            <td>WAIST</td>
            <td>23"</td>
            <td>24"</td>
            <td>25"</td>
            <td>26"</td>
            <td>27"</td>
            <td>28"</td>
            <td>29"</td>
            <td>30.5"</td>
            <td>32"</td>
            <td>33.5"</td>
            <td>35"</td>
            </tr>
            <tr>
            <td>HIPS</td>
            <td>32.5"</td>
            <td>33.5"</td>
            <td>34.5"</td>
            <td>35.5"</td>
            <td>36.5"</td>
            <td>37.5"</td>
            <td>38.5"</td>
            <td>40"</td>
            <td>41.5"</td>
            <td>43"</td>
            <td>44.5"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="how-to-measure mb-5">
        <div class="h4">how to measure</div>
        <ul>
        <li>
            For the best fit, measure over the undergarments you'll be wearing.
            Stand with your feet approximately 12" apart.
        </li>
        <li>
            Bust: Measure around the chest at the fullest part of the bust. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Natural Waist: Measure around your waist at the narrowest part. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Hips: Measure around your hips at widest part. Usually about eight
            inches below waist. The tape should be held securely around the body but
            not tight.
        </li>
        </ul>
    </div>	
    </div>

    <div class="size-chart size-sub-chart display_none" id="tall">
    <div class="mb-5 sct sizeChartTable-mobile sm:display_none display_block">
        <table class="table-sc-2 table-auto-mobile">
        <thead>
            <tr>
            <td>TALL</td>
            <td>SIZE</td>
            <td>BUST</td>
            <td>WAIST</td>
            <td>HIPS</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>XS</td>
            <td>0</td>
            <td>32.5"</td>
            <td>25"</td>
            <td>34.5"</td>
            </tr>
            <tr>
            <td>XS</td>
            <td>2</td>
            <td>33.5"</td>
            <td>26"</td>
            <td>35.5"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>4</td>
            <td>34.5"</td>
            <td>27"</td>
            <td>36.5"</td>
            </tr>
            <tr>
            <td>S</td>
            <td>6</td>
            <td>35.5"</td>
            <td>28"</td>
            <td>37.5"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>8</td>
            <td>36.5"</td>
            <td>29"</td>
            <td>38.5"</td>
            </tr>
            <tr>
            <td>M</td>
            <td>10</td>
            <td>37.5"</td>
            <td>30"</td>
            <td>39.5"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>12</td>
            <td>39"</td>
            <td>31.5"</td>
            <td>41"</td>
            </tr>
            <tr>
            <td>L</td>
            <td>14</td>
            <td>40.5"</td>
            <td>33"</td>
            <td>42.5"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>16</td>
            <td>42"</td>
            <td>34.5"</td>
            <td>44"</td>
            </tr>
            <tr>
            <td>XL</td>
            <td>18</td>
            <td>43.5"</td>
            <td>36"</td>
            <td>45.5"</td>
            </tr>
            <tr>
            <td>XXL</td>
            <td>20</td>
            <td>45"</td>
            <td>37.5"</td>
            <td>47"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="mb-5 sct sizeChartTable sm:display_block display_none">
    <table class="table-sc-2 table-auto">
        <thead>
            <th colspan="12">
            Our tall styles are proportioned to fit women over 5'8" tall
            </th>
            <tr>
            <td>TALL</td>
            <td>XS</td>
            <td>XS</td>
            <td>S</td>
            <td>S</td>
            <td>M</td>
            <td>M</td>
            <td>L</td>
            <td>L</td>
            <td>XL</td>
            <td>XL</td>
            <td>XXL</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>SIZE</td>
            <td>0</td>
            <td>2</td>
            <td>4</td>
            <td>6</td>
            <td>8</td>
            <td>10</td>
            <td>12</td>
            <td>14</td>
            <td>16</td>
            <td>18</td>
            <td>20</td>
            </tr>
            <tr>
            <td>BUST</td>
            <td>32.5"</td>
            <td>33.5"</td>
            <td>34.5"</td>
            <td>35.5"</td>
            <td>36.5"</td>
            <td>37.5"</td>
            <td>39"</td>
            <td>40.5</td>
            <td>42"</td>
            <td>43.5"</td>
            <td>45"</td>
            </tr>
            <tr>
            <td>WAIST</td>
            <td>25"</td>
            <td>26"</td>
            <td>27"</td>
            <td>28"</td>
            <td>29"</td>
            <td>30"</td>
            <td>31.5"</td>
            <td>33</td>
            <td>34.5"</td>
            <td>36"</td>
            <td>37.5"</td>
            </tr>
            <tr>
            <td>HIPS</td>
            <td>34.5"</td>
            <td>35.5"</td>
            <td>36.5"</td>
            <td>37.5"</td>
            <td>38.5"</td>
            <td>39.5"</td>
            <td>41"</td>
            <td>42.5"</td>
            <td>44"</td>
            <td>45.5"</td>
            <td>47"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="how-to-measure mb-5">
        <div class="h4">how to measure</div>
        <ul>
        <li>
            For the best fit, measure over the undergarments you'll be wearing.
            Stand with your feet approximately 12" apart.
        </li>
        <li>
            Bust: Measure around the chest at the fullest part of the bust. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Natural Waist: Measure around your waist at the narrowest part. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Hips: Measure around your hips at widest part. Usually about eight
            inches below waist. The tape should be held securely around the body but
            not tight.
        </li>
        </ul>
    </div>
    </div>

    <div class="size-chart size-sub-chart display_none" id="shoes">

    <div class="mb-5 sct sizeChartTable-mobile sm:display_none display_block">
        <table class="table-sc-3 table-auto-mobile">
        <thead>
            <tr>
            <td>U.S. SIZES</td>
            <td>INCHES</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>6</td>
            <td>9.44"</td>
            </tr>
            <tr>
            <td>6.5</td>
            <td>9.61"</td>
            </tr>
            <tr>
            <td>7</td>
            <td>9.78"</td>
            </tr>
            <tr>
            <td>7.5</td>
            <td>9.95"</td>
            </tr>
            <tr>
            <td>8</td>
            <td>10.11"</td>
            </tr>
            <tr>
            <td>8.5</td>
            <td>10.28"</td>
            </tr>
            <tr>
            <td>9</td>
            <td>10.45"</td>
            </tr>
            <tr>
            <td>9.5</td>
            <td>10.61"</td>
            </tr>
            <tr>
            <td>10</td>
            <td>10.78"</td>
            </tr>
            <tr>
            <td>11</td>
            <td>11.11"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="mb-5 sct sizeChartTable sm:display_block display_none">
    <table class="table-sc-3 table-auto">
        <thead>
            <th colspan="11">Size Chart for Women's Shoes</th>
            <tr>
            <td class="text-xs">U.S. SIZES</td>
            <td>6</td>
            <td>6.5</td>
            <td>7</td>
            <td>7.5</td>
            <td>8</td>
            <td>8.5</td>
            <td>9</td>
            <td>9.5</td>
            <td>10</td>
            <td>11</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>INCHES</td>
            <td>9.44"</td>
            <td>9.61"</td>
            <td>9.78"</td>
            <td>9.95"</td>
            <td>10.11"</td>
            <td>10.28"</td>
            <td>10.45"</td>
            <td>10.61"</td>
            <td>10.78</td>
            <td>11.11</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="how-to-measure mb-5">
        <div class="h4">how to measure</div>
        <ul>
        <li>
            For the best fit, measure over the undergarments you'll be wearing.
            Stand with your feet approximately 12" apart.
        </li>
        <li>
            Bust: Measure around the chest at the fullest part of the bust. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Natural Waist: Measure around your waist at the narrowest part. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Hips: Measure around your hips at widest part. Usually about eight
            inches below waist. The tape should be held securely around the body but
            not tight.
        </li>
        </ul>
    </div>
    </div>

    <div class="size-chart size-sub-chart display_none" id="plus">
    <div class="mb-5 sct sizeChartTable-mobile sm:display_none display_block">
        <table class="table-sc-4 table-auto-mobile">
        <thead>
            <tr>
            <td>NYCO PLUS</td>
            <td>SIZE</td>
            <td>BUST</td>
            <td>WAIST</td>
            <td>HIPS</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>14W</td>
            <td>1X</td>
            <td>43.5</td>
            <td>37</td>
            <td>46.5</td>
            </tr>
            <tr>
            <td>16W</td>
            <td>1X</td>
            <td>45.5</td>
            <td>39</td>
            <td>48.5</td>
            </tr>
            <tr>
            <td>18W</td>
            <td>2X</td>
            <td>47.5</td>
            <td>41</td>
            <td>50.5</td>
            </tr>
            <tr>
            <td>20W</td>
            <td>2X</td>
            <td>49.5</td>
            <td>43</td>
            <td>52.5</td>
            </tr>
            <tr>
            <td>22W</td>
            <td>3X</td>
            <td>51.5</td>
            <td>45</td>
            <td>54.5</td>
            </tr>
            <tr>
            <td>24W</td>
            <td>3X</td>
            <td>53.5</td>
            <td>47</td>
            <td>56.5</td>
            </tr>
            <tr>
            <td>26W</td>
            <td>4X</td>
            <td>55.5</td>
            <td>49</td>
            <td>58.5</td>
            </tr>
            <tr>
            <td>28W</td>
            <td>4X</td>
            <td>57.5</td>
            <td>51</td>
            <td>60.5</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="mb-5 sct sizeChartTable sm:display_block display_none">
    <table class="table-sc-4 table-auto">
        <thead>
            <th colspan="9">Size Chart For Plus Sized Women</th>
            <tr>
            <td class="text-xs">NYCO PLUS</td>
            <td>14W</td>
            <td>16W</td>
            <td>18W</td>
            <td>20W</td>
            <td>22W</td>
            <td>24W</td>
            <td>26W</td>
            <td>28W</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>SIZE</td>
            <td>1X</td>
            <td>1X</td>
            <td>2X</td>
            <td>2X</td>
            <td>3X</td>
            <td>3X</td>
            <td>4X</td>
            <td>4X</td>
            </tr>
            <tr>
            <td>BUST</td>
            <td>43.5</td>
            <td>45.5</td>
            <td>47.5</td>
            <td>49.5</td>
            <td>51.5</td>
            <td>53.5</td>
            <td>55.5</td>
            <td>57.5</td>
            </tr>
            <tr>
            <td>WAIST</td>
            <td>37</td>
            <td>39</td>
            <td>41</td>
            <td>43</td>
            <td>45</td>
            <td>47</td>
            <td>49</td>
            <td>51</td>
            </tr>
            <tr>
            <td>HIPS</td>
            <td>46.5</td>
            <td>48.5</td>
            <td>50.5</td>
            <td>52.5</td>
            <td>54.5</td>
            <td>56.5</td>
            <td>58.5</td>
            <td>60.5</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="how-to-measure mb-5">
        <div class="h4">how to measure</div>
        <ul>
        <li>
            For the best fit, measure over the undergarments you'll be wearing.
            Stand with your feet approximately 12" apart.
        </li>
        <li>
            Bust: Measure around the chest at the fullest part of the bust. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Natural Waist: Measure around your waist at the narrowest part. The tape
            should be held securely around the body but not tight.
        </li>
        <li>
            Hips: Measure around your hips at widest part. Usually about eight
            inches below waist. The tape should be held securely around the body but
            not tight.
        </li>
        </ul>
    </div>
    </div>

    <div class="size-chart size-sub-chart display_none" id="ftf">
    <div data-role="content">

            <div class="mb-5">

            <p class="italic">Reference the below

                measurement before

                the purchase.</p>

                <table class="table-auto">

                <thead>

                <tr>

                    <td>FTF</td>

                    <td>0</td>

                    <td>1</td>

                    <td>2</td>

                    <td>3</td>

                    <td>4</td>

                </tr>

                </thead>

                <tbody>

                <tr>

                    <td>US</td>

                    <td>XL</td>

                    <td>1X</td>

                    <td>2X</td>

                    <td>3X</td>

                    <td>4X</td>

                </tr>

                <tr>

                    <td>SIZES</td>

                    <td>12</td>

                    <td>14-16</td>

                    <td>18-20</td>

                    <td>22-24</td>

                    <td>26-28</td>

                </tr>

                <tr>

                    <td>WAIST</td>

                    <td>34"</td>

                    <td>36-38"</td>

                    <td>39-41"</td>

                    <td>42.5-44.5"</td>

                    <td>47-49.5"</td>

                </tr>

                <tr>

                    <td>HIP</td>

                    <td>44"</td>

                    <td>46-48"</td>

                    <td>49-51"</td>

                    <td>52.5-54.5"</td>

                    <td>57-59.5"</td>

                </tr>

                </tbody>

            </table>

            <br/>

            <table>

                <thead>

                    <tr>

                        <td>FTF</td>

                        <td>12</td>

                        <td>14</td>

                        <td>16</td>

                        <td>18</td>

                        <td>20</td>

                        <td>22</td>

                        <td>24</td>

                        <td>26</td>

                        <td>28</td>
                    </tr>

                </thead>

                <tbody>

                    <tr>

                        <td>US</td>

                        <td>XL</td>

                        <td colspan="2">1X</td>

                        <td colspan="2">2X</td>

                        <td colspan="2">3X</td>

                        <td colspan="2">4X</td>

                    </tr>

                    <tr>

                        <td>WAIST</td>

                        <td>34"</td>

                        <td>36"</td>

                        <td>38"</td>

                        <td>40"</td>

                        <td>42"</td>

                        <td>44"</td>

                        <td>47"</td>

                        <td>50"</td>

                        <td>53"</td>

                    </tr>

                    <tr>

                        <td>HIP</td>

                        <td>44"</td>

                        <td>46"</td>

                        <td>48"</td>

                        <td>50"</td>

                        <td>52"</td>

                        <td>54"</td>

                        <td>57"</td>

                        <td>60"</td>

                        <td>63"</td>

                    </tr>

                </tbody>
            </table>

            </div>

            <div class="how-to-measure mb-5">

            <div class="h4">how to measure</div>

            <ul>

                <li>

                For the best fit, measure over the undergarments you'll be wearing. Stand with your feet approximately

                12" apart.</li>

                <li>

                Bust: Measure around the chest at the fullest part of the bust. The tape should be held securely

                around the body but not tight.</li>

                <li>

                Natural Waist: Measure around your waist at the narrowest part. The tape should be held securely

                around the body but not tight.</li>

                <li>

                Hips: Measure around your hips at widest part. Usually about eight inches below waist. The tape should

                be held securely around the body but not tight.</li>

            </ul>

            </div>

        </div>
    </div>

    <div class="size-chart size-sub-chart display_none" id="plus-shoes">
    <div data-role="content">
    <div class="mb-5">
        <p class="italic">Reference the below measurement before the purchase.</p>
        <table class="table-auto">
        <thead>
            <tr>
            <td>FTF Size</td>
            <td>Length (in)</td>
            <td>Width (in)</td>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td>7W</td>
            <td>9.7"</td>
            <td>3.3"</td>
            </tr>
            <tr>
            <td>8W</td>
            <td>10"</td>
            <td>3.4"</td>
            </tr>
            <tr>
            <td>9W</td>
            <td>10.3"</td>
            <td>3.5"</td>
            </tr>
            <tr>
            <td>10W</td>
            <td>10.6"</td>
            <td>3.5"</td>
            </tr>
            <tr>
            <td>11W</td>
            <td>11"</td>
            <td>3.6"</td>
            </tr>
            <tr>
            <td>12W</td>
            <td>11.3"</td>
            <td>3.7"</td>
            </tr>
            <tr>
            <td>13W</td>
            <td>11.6"</td>
            <td>3.8"</td>
            </tr>
            <tr>
            <td>14W</td>
            <td>12"</td>
            <td>3.9"</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="how-to-measure mb-5">
        <div class="h4">how to measure</div>
        <ul>
        <li> For the best fit, measure over the undergarments you'll be wearing. Stand with your feet approximately 12" apart.</li>
        <li> Bust: Measure around the chest at the fullest part of the bust. The tape should be held securely around the body but not tight.</li>
        <li> Natural Waist: Measure around your waist at the narrowest part. The tape should be held securely around the body but not tight.</li>
        <li> Hips: Measure around your hips at widest part. Usually about eight inches below waist. The tape should be held securely around the body but not tight.</li>
        </ul>
    </div>
    </div>
    </div>
    </div>
    </div>
    `;
    wrapper.querySelector('.size-chart-close').addEventListener('click', closeSizeChartModal);
    wrapper.addEventListener('click', (e) => {
        if (e.target === wrapper) closeSizeChartModal();
    });
    wrapper.querySelectorAll('.chart-section-item').forEach(chartItem => {
        chartItem.addEventListener('click', (e) => {
            console.log(e.target.innerHTML.trim());
            const chartKey = e.target.innerHTML.trim();
            wrapper.querySelectorAll('.size-sub-chart').forEach(subChartElem => {
                subChartElem.classList.add('display_none');
            })
            wrapper.querySelectorAll('.chart-section-item').forEach(chartItem1 => {
                chartItem1.classList.remove('active');
            })
            e.target.classList.add('active');
            const selectedSubChartElem = document.querySelector(`#${chartKey}`);
            selectedSubChartElem.classList.remove('display_none');
        })
    })   
    
    return wrapper;
}

// document.addEventListener("DOMContentLoaded", function() {
//     const sizeChartBtn = document.getElementById('size-chart');
//     sizeChartBtn.addEventListener('click', (e) => {
//         e.preventDefault();
//         showSizeChart(e);
//     })
// })